import React from "react";
import Spinner from "react-bootstrap/Spinner";

const style = {
  position: "fixed",
  top: "50vh",
  left: "50vw",
  zIndex: "1000",
  transform: "translate(-50%, -50%)",
};

export default function Loading(props) {
  return (
    <div style={style}>
      <Spinner variant="dark" animation="border" role="status" {...props}>
        <span className="visually-hidden">Ladataan</span>
      </Spinner>
    </div>
  );
}
